import React from "react";

const AttachmentIcon = ({ fill }) => {
  return (
    <svg
      id="atch_ic1"
      xmlns="http://www.w3.org/2000/svg"
      width="27.353"
      height="24.371"
      viewBox="0 0 27.353 24.371"
    >
      <path
        id="Path_345"
        data-name="Path 345"
        d="M36.377,969.746a7.029,7.029,0,0,0-9.94,0L12.522,983.662a4.92,4.92,0,0,0,6.958,6.958L33.4,976.7a2.811,2.811,0,1,0-3.976-3.976L17.492,984.656a.7.7,0,1,0,.994.994l11.928-11.928A1.406,1.406,0,0,1,32.4,975.71L18.486,989.626a3.514,3.514,0,0,1-4.97-4.97L27.431,970.74a5.623,5.623,0,0,1,7.952,7.952L23.455,990.619a.7.7,0,1,0,.994.994l11.928-11.928A7.029,7.029,0,0,0,36.377,969.746Z"
        transform="translate(-11.083 -967.687)"
        fill={fill ? fill : "#707070"}
      />
    </svg>
  );
};
export default AttachmentIcon;
